import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  Project,
  ProjectResource,
  ResourceAllocations,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  resourceAllocations: ResourceAllocations;
  isDirty: boolean;
  retrieveProjectResourceAllocations(
    request: Boundaries["retrieveProjectResourceAllocations"]["request"],
  ): void;
}

function useRetrieveProjectResourceAllocations(
  project: Identifiable<Project>,
  projectResource: Identifiable<ProjectResource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectResourceAllocationsRequestPending(
        project,
        projectResource,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectResourceAllocationsRequestSuccess(
        project,
        projectResource,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectResourceAllocationsRequestFailure(
        project,
        projectResource,
      ),
    ),
    resourceAllocations: useSelector(() =>
      selector.getProjectResourceAllocations(project, projectResource),
    ),
    isDirty: useSelector(() =>
      selector.isProjectResourceAllocationsDirty(project, projectResource),
    ),
    retrieveProjectResourceAllocations: core.retrieveProjectResourceAllocations,
  };
}

export { useRetrieveProjectResourceAllocations };
